import AcknowledgeEvent from "./event/AcknowledgeEvent.js";
import CreateEvent from "./event/CreateEvent.js";
import ModelFactory from "../../ModelFactory.js";
import NotifyEvent from "./event/NotifyEvent.js";
import PublishEvent from "./event/PublishEvent.js";
import ViewEvent from "./event/ViewEvent.js";
import WithdrawEvent from "./event/WithdrawEvent.js";

/**
 * `PeriodReportEventFactory` instantiates the correct report event depending
 * on the event type.
 */
class PeriodReportEventFactory extends ModelFactory {
	allClasses() {
		return [
			AcknowledgeEvent,
			CreateEvent,
			PublishEvent,
			WithdrawEvent,
			NotifyEvent,
			ViewEvent,
		];
	}
}

const periodReportEventFactory = new PeriodReportEventFactory();

export default periodReportEventFactory;
